import { Zap, Timer, Users, Trophy, Swords } from 'lucide-react';

export const NavBar = ({ currentView, setCurrentView, pactNotification }) => {
  const tabs = [
    { id: 'home',      icon: Zap,    label: 'CHALLENGES', color: 'lime'   },
    { id: 'roulette',  icon: Timer,  label: 'EXECUTE',    color: 'yellow' },
    { id: 'community', icon: Users,  label: 'FEED',       color: 'red'    },
    { id: 'profile',   icon: Trophy, label: 'YOU',        color: 'blue'   },
    { id: 'pact',      icon: Swords, label: 'PACT',       color: 'purple' },
  ];

  return (
    <div className="grid grid-cols-5 gap-1 sm:gap-2 mb-4 sm:mb-5 px-3 sm:px-4">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => setCurrentView(tab.id)}
          className={`relative flex flex-col sm:flex-row items-center justify-center gap-0.5 sm:gap-1.5 px-1 sm:px-3 py-2.5 sm:py-3.5 font-black uppercase tracking-wide transition-all border-2 text-[10px] sm:text-xs active:scale-95 touch-manipulation min-h-[52px] sm:min-h-[56px] ${
            currentView === tab.id
              ? `bg-${tab.color}-500 text-black border-${tab.color}-400 shadow-lg`
              : `bg-black text-${tab.color}-500 border-${tab.color}-500 hover:bg-${tab.color}-500 hover:text-black`
          }`}
        >
          <tab.icon size={16} className="flex-shrink-0" />
          <span className="leading-tight">{tab.label}</span>
          {tab.id === 'pact' && pactNotification && (
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
          )}
        </button>
      ))}
    </div>
  );
};
